module.exports = __webpack_public_path__ + "static/media/logo_sdi.e5603ed3.png";